// eslint-disable-next-line no-restricted-imports
import { Pagination as AntdPagination } from 'antd'
import { type ComponentPropsWithoutRef, type FC } from 'react'

import { type PageEntity } from '@/libs/api'

type Props = Omit<
  ComponentPropsWithoutRef<typeof AntdPagination>,
  'current' | 'total' | 'pageSize' | 'showTotal'
> & {
  /** ページネーション情報 */
  entity?: PageEntity | null
  /**
   * ページサイズを表示するかどうか
   * @default true
   */
  showSizeChanger?: boolean
}

/**
 * Antd の Pagination をラップしたコンポーネント
 * - ページネーションの状態を PageEntity で受け取れるように対応
 * - size の初期値を small に設定
 */
export const Pagination: FC<Props> = ({
  entity,
  disabled,
  size = 'small',
  showSizeChanger = true,
  onChange,
  ...props
}) => {
  return (
    <div className="flex items-center gap-3">
      <AntdPagination
        showSizeChanger={showSizeChanger}
        disabled={!entity || disabled}
        current={entity?.page}
        total={entity?.total}
        pageSize={entity?.take ?? 0}
        size={size}
        onChange={onChange}
        {...props}
      />
    </div>
  )
}
